import Vue from 'vue';
import _ from 'lodash';

/**
 * Example usage:
 * <div v-gen:asdf.id>
 *     becomes:
 * <div id="my-component-14--asdf">
 */
Vue.directive('gen', function (el, binding, vnode) {
    // The list of attributes to fill with the generator
    const elementKeys = _.map(binding.modifiers, (value, key) => value ? key : undefined).filter(key => key);
    // The id is build from the name of the parent component and the provided
    const componentName = vnode.context.$vnode.tag;
    // The scope allows for multiple strings to be generated in the same component
    let id = componentName;
    if (binding.arg) {
        id += '--' + binding.arg;
    }
    if (binding.value) {
        id += '--' + binding.value;
    }
    elementKeys.forEach(key => el.setAttribute(key, id));
});



// WEBPACK FOOTER //
// ./src/unique_id_helper.js